module.exports = __webpack_public_path__ + "ptc_nakagawa_S2.ca198605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_S2.jpg
// module id = bR8k
// module chunks = 0